import { Html5QrcodeScanner } from "html5-qrcode";
import { useEffect, useState } from "react";
import { Button, Card } from "react-bootstrap";
const qrcodeRegionId = "html5qr-code-full-region";

// https://github.com/scanapp-org/html5-qrcode-react
// https://github.com/mebjas/html5-qrcode

export interface IQRCodeReaderProps {
    onScanSuccess: (decodedText: string, decodedResult: any) => void;
    verbose?: boolean;
    fps?: number;
    qrbox?: number;
    aspectRatio?: number;
    disableFlip?: boolean;
    supportedScanTypes?: any[];
}

const QRCodeReader = (props: IQRCodeReaderProps) => {
    const [html5QrcodeScanner, setHtml5QrcodeScanner] = useState<Html5QrcodeScanner>();

    useEffect(() => {
        return () => {
            if (html5QrcodeScanner) {
                html5QrcodeScanner
                    .clear()
                    .catch(error => {
                        console.error("Failed to clear html5QrcodeScanner. ", error);
                    });
            }
        };
    }, [html5QrcodeScanner]);

    const startScanner = () => {
        console.log("Setting up qrcode");
        // when component mounts
        const config = {
            fps: props.fps ?? 10,
            qrbox: props.qrbox ?? 250,
            aspectRatio: props.aspectRatio ?? 1,
            disableFlip: props.disableFlip ?? false,
            howZoomSliderIfSupported: true,
            defaultZoomValueIfSupported: 2,
            useBarCodeDetectorIfSupported: true,
            willReadFrequently: true,
            supportedScanTypes: props.supportedScanTypes ?? [0, 1] // 0 = camera, 1 = file
        };

        const verbose = props.verbose === true;
        const html5QrcodeScanner =
            new Html5QrcodeScanner(
                qrcodeRegionId,
                config,
                verbose);

        html5QrcodeScanner.render(
            props.onScanSuccess,
            (error) => { });

        setHtml5QrcodeScanner(html5QrcodeScanner);
    };

    return (
        <Card className="mb-3 mt-3">
            <Card.Body>
                <Card.Title>
                </Card.Title>
                {
                    !html5QrcodeScanner &&
                    <Button
                        variant="primary"
                        style={{
                            width: "100%"
                        }}
                        onClick={startScanner}>Start QR Code Scanner</Button>
                }
                <div id={qrcodeRegionId} />
            </Card.Body>
        </Card>
    );
}

export default QRCodeReader;